import { SortingState } from '@tanstack/react-table';
import { isEqual } from 'lodash';
import { createParser } from 'nuqs';

export const parseAsSorting = createParser<SortingState>({
  parse(value) {
    const [id, ascending] = value.split(':');
    if (!id) return [];

    return [{ id, desc: !ascending }];
  },
  serialize(value) {
    const sorting = value.length ? value[0] : undefined;
    if (!sorting) return '';

    if (sorting.desc) return sorting.id;

    return `${sorting.id}:ascending`;
  },
  eq: isEqual,
});
